import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Users, userrights, pairText, slaNote } from './../../models/users';

import { SpinnerVisibilityService } from 'ng-http-loader';
import { AdminApiService } from './../../services/admin.service';
import Swal from 'sweetalert2'
import { ToasterService } from '../../toaster.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { tenant } from '../../models/admin';
import { UserService } from '../../services/user.service';
import { NgRecaptcha3Service } from "ng-recaptcha3";
import { RSAHelper } from '../../models/RSAHelper';


import { UserInfo } from '../../models/userinfo';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-login-external',
  templateUrl: './login-external.component.html',
  styleUrls: ['./login-external.component.css'],
  styles: [`
    #main-menu {
      display: none;
    }
  `],
})
export class LoginExternalComponent implements OnInit {
  loginForm: FormGroup;
  modalFPassword: BsModalRef;
  PingEnabled: boolean = false;
  authorized: boolean = false;
  userInfo: UserInfo | null;

  
  @ViewChild('agreementtemplate', { static: false }) agreementtemplate: TemplateRef<any>;
  modalRef: BsModalRef;
  submitted: boolean = false;

  invalid: boolean = false;
  //user: Users;
  usermodel: any = {};
  isError: boolean = false;
  returnUrl: string = '';
  loading = false;
  languages: any[];
  signintext: string = 'SIGN IN';
  isPageLoad: boolean = false;
  isPageSwitch: boolean = false;
  userRights_data: any;
  userroleType: number;
  tenantUno: number=1;
    isforgot: boolean;
  lockedCount: number=0;
  tenantInfo: any = [];
  user: any = {};
  IsBenchmarkAgreement: number = 0;
  loginUserID: string = '';
  strK1: string;
  strI1: string;
  
  constructor(private formBuilder: FormBuilder, private modalService: BsModalService, private toaster: ToasterService, public router: Router, private spinner: SpinnerVisibilityService, public restApi: AdminApiService, private userService: UserService, private recaptcha3: NgRecaptcha3Service, public RASHelper: RSAHelper) {
    this.PingEnabled = environment.PingEnabled;
  }
  //public isVisible = false;
  //public isVisible: boolean = null;
  isHidden: boolean = true;
  isDisabled = false;
   public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  recapchaToken: string = '';
  
  ngOnInit() {
    
    //if (this.PingEnabled) {
    //  this.Authorize();
    //}
    localStorage.removeItem('externalUseraccess');
    localStorage.setItem('externalUseraccess', '{"isExternalUser":"' + 1 + '"}');

    this.loadpairText();
    this.loginForm = this.formBuilder.group({
      tenant: ['1'],
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    //let ft = document.getElementById("footer");
    //if(ft!=null && ft!=undefined)
    //{
    // ft.style.display='none';
    //}
    //let ft1 = document.getElementById("main-menu");
    //if (ft1 != null && ft1 != undefined) {
    //  ft1.style.display = 'none';
    //}
    //console.log(this.isHidden); //console shows true
    setTimeout(() => {
      
      var divleft = document.getElementById("main-menu");

      if (divleft != null && divleft != undefined) {
        divleft.style.display = 'none';
      }
    }, 1000);
   
   
}
  get f() { return this.loginForm.controls; }
  onSubmit() {
    
    this.invalid = false;
    this.submitted = true;
    this.tenantUno = 1;//this.f.tenant.value;
    // stop here if form is invalid
    if (this.loginForm.invalid) {

      this.toaster.show('error', 'Error', 'Please enter all required fields');
      return;
    }
    else {
      if (this.f.username.value.trim().toLowerCase() != "" && this.f.password.value.trim().toLowerCase() != "") {
        this.isDisabled = true;

        if (this.PingEnabled) {
          let utName = this.f.username.value.trim().toLowerCase();
          utName = (utName.indexOf("@dewa.gov.ae") >= 0) ? utName.split("@")[0] : utName

          if (utName.indexOf("@") < 0) {
            this.isDisabled = false;
            this.toaster.show('error', 'Error', 'Kindly use OneID login to access Musherat');
            return false;
          }
          else {
            environment.isExternalUser = true;
          }

        }
        else {
          environment.isExternalUser = true;
        }

        this.recaptcha3.getToken().then(
          tv => {
            
            //console.log('captcha token created');
            this.AdLogin(tv);
          },
          error => {
            // handle error here
            console.log(error);
            this.invalid = true;
            this.isDisabled = false;
            this.toaster.show('error', 'Error', 'Please enter all required fields');
          }
        );
      }
      else {
        this.invalid = true;
        this.toaster.show('error', 'Error', 'Please enter all required fields');
      }
    }
  }

  //Authendicate Ad user
  AdLogin(tv:string) {
    if (this.lockedCount == 5) {
      let objUser = new Users();
      objUser.userName = this.f.username.value.trim();
      objUser.condition = 4;
      objUser.confirmPassword = '';
      objUser.password = '';
      objUser.userUno = '';
      objUser.tv = tv;
      this.restApi.resetPassword(objUser)
        .subscribe(data => {
          if (data == "success") {
            this.lockedCount = 0;
            this.toaster.show('error', 'Error','Please enter the valid email or contact your system administrator.')
          }
          else {
            this.toaster.show('error', 'Error','Please enter the valid email or contact your system administrator.')
          }
        },
          () => {

          }
        ).add(() => {

        });

      return;
    }
    let objusers = new Users;
    this.isError = false;
    
   
    
    
    var userName = this.RASHelper.encryptWithPublicKey(this.f.username.value.trim());
    var password = this.RASHelper.encryptWithPublicKey(this.f.password.value.trim());
    //console.log('login credentials are encrypted');
    objusers.userName = userName;
    objusers.password = password;
    objusers.tenantUno = 1;//this.tenantUno;
    objusers.isLogin = true;
    objusers.tv = tv;
    this.spinner.show();
    //debugger;
    this.restApi.AdUserAuthenticate(objusers).subscribe(
      data => {
        //debugger;
        //console.log('login credentials are encrypted');
        let rtndata:any = data;
        let objdata: any = [];
        objdata = rtndata.data[0];
    //this.user = objdata;
   this.isError = (objdata.error != "" && objdata.error != null) ? true : false;
   // this.isError = false;
        if (!this.isError) {
          this.spinner.hide();
          
          var token = objdata.token;
          if (token == null) {
            //console.log('jwt token not generated');
            this.isDisabled = false;
            this.toaster.show('error', 'Error', 'Invalid username or password. Please try again later or contact your system administrator.');
            this.spinner.hide();
            return false;
          }
          localStorage.setItem('accessinfo', '{"token":"' + token + '"}');
          

          this.restApi.GetUserInfo_ByUserID(objusers).subscribe(
            data => {
             
              let objdata: any = data;
              if (objdata!=null && objdata.length > 0) {
                this.checkSR(objdata);
              }
              else {
                this.isDisabled = false;
               // Swal.fire('Error', 'Your Account is locked or not matched, contact your system administrator.', 'error');
                this.toaster.show('error', 'Error', 'Invalid username or password. Contact your admin in case you do not remember your password');
              }
            });

        }
        else {

          //console.log(objdata.error);
          this.isDisabled = false;
          this.lockedCount = this.lockedCount + 1;
          this.loading = false;
          this.isforgot = false;
          if (this.f.username.value.trim().indexOf('@') >= 0 && !(this.f.username.value.trim().indexOf('@dewa.gov.ae') >= 0)) {
            this.isforgot = true;
          }
          this.toaster.show('error', 'Error','Invalid user name or password. Please try again later or contact your system administrator.');
          
        
          //Swal.fire('Error', 'Invalid username or password. Please try again later or contact your system administrator.');
         // this.toaster.show('error', 'Error', 'Invalid username or password. Please try again later or contact your system administrator.');
         //this.spinner.hide();
        }
      },
      (err) => {
        console.log(err);
        this.isDisabled = false;
        if (err.status == 401) {
          this.lockedCount = this.lockedCount + 1;
          this.loading = false;
          this.isforgot = false;
          if (this.f.username.value.trim().indexOf('@') >= 0 && !(this.f.username.value.trim().indexOf('@dewa.gov.ae') >= 0)) {
            this.isforgot = true;
          }
        }
        
        
        this.toaster.show('error', 'Error', 'Invalid user name or password. Please try again later or contact your system administrator.');

        //console.log(err);
        //this.toaster.show('error', 'Error', 'Invalid username or password. Please try again later or contact your system administrator.');
      },

      //(error:any) => {
      //  alert(error);
      //  
      // // this._toastr.error('Invalid user name or password. Please try again later or contact your systems administrator.', '', { toastLife: 2000 });
      //  //Swal.fire('Error', 'Invalid username or password. Please try again later or contact your system administrator.');
      //  this.toaster.show('error', 'Error', 'Invalid username or password. Please try again later or contact your system administrator.');
      //  this.spinner.hide();
      //},
      () => {
       //'onCompleted' callback.
       
        this.spinner.hide();
      })



  }

  checkSR(data: any) {

    try {

      var userid = this.RASHelper.encryptWithPublicKey(data[0].id);

      var roleType = (data[0].userTypeNameEn != null && data[0].userTypeNameEn != '') ? data[0].userTypeNameEn : 'Normal User';
      var userName = (data[0].userName != null && data[0].userName != '') ? data[0].userName : '';

      let objUser = new slaNote;
      objUser.userUno = userid;
      objUser.type = roleType;
      objUser.userName = userName;
      //debugger;
      this.restApi.CheckSR(objUser).subscribe(
        res => {
          
          //Get User default information

          var displayname = (data[0].displayName != null && data[0].displayName != '') ? (data[0].displayName) : '';
          var username = (data[0].userName != null && data[0].userName != '') ? (data[0].userName) : '';
          var firstname = (data[0].firstName != null && data[0].firstName != '') ? (data[0].firstName) : '';
          var lastname = (data[0].lastname != null && data[0].lastname != '') ? (data[0].lastname) : '';
          var email = (data[0].emailId != null && data[0].emailId != '') ? (data[0].emailId) : '';
          var role = (data[0].role != null && data[0].role != '') ? data[0].role : '';
          // var token = data[0].token;
          var picture = data[0].profilePicture;
          var desingation = (data[0].designation != null && data[0].designation != '') ? (data[0].designation) : '';
          var division = (data[0].division != null && data[0].division != '') ? (data[0].division) : '';


          var divisionUno = (data[0].divisionUno != null && data[0].divisionUno != '') ? data[0].divisionUno : 0;
          var versionNumber = (data[0].versionNo != null && data[0].versionNo != '') ? data[0].versionNo : '1.0';

          var currentYear = (data[0].currentYear != null && data[0].currentYear != '') ? data[0].currentYear : '1';
          var currentHalf = (data[0].currentHalf != null && data[0].currentHalf != '') ? data[0].currentHalf : '1';
          var currentQuarter = (data[0].currentQuarter != null && data[0].currentQuarter != '') ? data[0].currentQuarter : '1';
          var currentMonth = (data[0].currentMonth != null && data[0].currentMonth != '') ? data[0].currentMonth : '1';
          var wellperformKPIRange = (data[0].wellperformKPIRange != null && data[0].wellperformKPIRange != '') ? data[0].wellperformKPIRange : '85';
          var userGroupUno = (data[0].userGroupUno != null && data[0].userGroupUno != '') ? data[0].userGroupUno : 0;
          var userGroup = (data[0].userGroupName != null && data[0].userGroupName != '') ? data[0].userGroupName : '';
          var userTypeUno = (data[0].userTypeUno != null && data[0].userTypeUno != '') ? data[0].userTypeUno : 0;
          var lastLogin = (data[0].lastLogin != null && data[0].lastLogin != '') ? data[0].lastLogin : '';

          //role = (userTypeUno == 1) ? 'Administrator' : (userTypeUno == 2) ? 'User' : (userTypeUno == 3) ? 'SLA Admin' : (userTypeUno == 4) ? 'SLA Coordinator' : 'User';
          //role = (userTypeUno == 1) ? 'Administrator' : (userTypeUno == 2) ? 'User' : (userTypeUno == 3) ? 'SLA Admin' : (userTypeUno == 4) ? 'SLA Coordinator' : (userTypeUno == 5) ? 'BM Champions' : (userTypeUno == 6) ? 'BM Administrator' : (userTypeUno == 7) ? 'BM Team' : (userTypeUno == 8) ? 'BM Visitor' : (userTypeUno == 9) ? 'DDAdmin' : (userTypeUno == 10) ? 'DDAdminReadonly' : 'User';
          role = (data[0].userTypeNameEn != null && data[0].userTypeNameEn != '') ? data[0].userTypeNameEn : 'User';

          this.userroleType = (userTypeUno != null && userTypeUno != undefined && userTypeUno != '') ? userTypeUno : 0;
          var isDynamicEntry = (data[0].isDynamicentry != null && data[0].isDynamicentry != '') ? data[0].isDynamicentry : 'false';

          var siteHeading = (data[0].siteHeading != null && data[0].siteHeading != '') ? data[0].siteHeading : 'Musherat';
          var slaname = (data[0].slaname != null && data[0].slaname != '') ? data[0].slaname : 'SLA';


          //TenantUser --For  Digital Dewa
          var tenantUno = (data[0].tenantUno != null && data[0].tenantUno != '') ? data[0].tenantUno : 1;
          var tenantDigitalUno = (data[0].tenantDigitlalUno != null && data[0].tenantDigitlalUno != '') ? data[0].tenantDigitlalUno : 2;

          var isDigitalUser = (tenantUno == tenantDigitalUno) ? true : false;
          this.tenantUno = tenantUno;

          this.IsBenchmarkAgreement = (data[0].isBenchmarkAgreement != null && data[0].isBenchmarkAgreement != '') ? data[0].isBenchmarkAgreement : 0;
          this.loginUserID = userid;

          setTimeout(() => {
            //Assign User value to the Session
            var struser = '{"id":"' + userid + '","tenantDigitalUno":"' + tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + displayname + '","username":"' + username + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","role":"' + role + '","desingation":"' + desingation + '","division":"' + division + '","divisionUno":"' + divisionUno + '","profilePicture":"' + picture + '","currentYear":"' + currentYear + '","currentHalf":"' + currentHalf + '","currentQuarter":"' + currentQuarter + '","currentMonth":"' + currentMonth + '","versionNumber":"' + versionNumber + '","wellperformKPIRange":"' + wellperformKPIRange + '","lastLogin":"' + lastLogin + '","tenantUno":"' + this.tenantUno + '","isDynamicEntry":"' + isDynamicEntry + '","siteHeading":"' + siteHeading + '","slaname":"' + slaname + '","userroleType":"' + this.userroleType + '","userGroupUno":"' + userGroupUno + '","userGroup":"' + userGroup + '"}';
            localStorage.removeItem('userinfo');
            localStorage.setItem('userinfo', struser);
            localStorage.removeItem('SlaPeformanceFilter');
            localStorage.removeItem('SlaKpiPeformanceFilter');

            var elementElBacktoTop = document.getElementById('elbacktotop') as HTMLInputElement;
            if (elementElBacktoTop != null) {
              elementElBacktoTop.style.display = "block";
            }
            this.loadUserRights(userid, userGroupUno);
          }, 500);

        },
        error => {
          this.isDisabled = false;
          //debugger;
          this.loading = false;
          //Assign User value to the Session
          var struser = '{"id":"' + userid + '"}';
          localStorage.removeItem('userinfo');
          localStorage.setItem('userinfo', struser);
          this.userService.logout();

        },
        () => {

        });

    } catch (e) {

      
    }
  }

  loadUserRights(userUno, userGroupUno) {
   
    this.spinner.show();
    let inpValue = new userrights();
    inpValue.languageUno = 1033;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = userUno;
    inpValue.pageUno = 0;
    inpValue.usergroupUno = userGroupUno;
   
    this.restApi.getUserRights(inpValue)
      .subscribe(data => {
        
        //this.userRights_data = data;

        //Assign User Rights value to the Session
       // var struserrights = '{"userrights_data":"' + JSON.stringify(data) + '"}';
        var struserrights = JSON.stringify(data);
        localStorage.removeItem('userrights');
        localStorage.setItem('userrights', struserrights);
        
        this.getTenantInfo(this.tenantUno);

        

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  openForgotPasswordModal(template: TemplateRef<any>) {

    this.modalFPassword = this.modalService.show(template, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));

  }

  forgotPassWord() {
    
    let objusers = new Users;
    var userName = this.f.username.value.trim();
    objusers.userName = userName;
    objusers.password = '';
    objusers.condition = 1;
    this.restApi.forgotPassWord(objusers)
      .subscribe(data => {
        

        //console.log(data, "userNameCheck");
      },
        (error) => {

          // this.spinner.hide();
        }
      ).add(() => {

        ///this.spinner.hide();
      });
    this.toaster.show('success', 'Success',"Successfully sent");
    this.modalFPassword.hide();
  }

  getTenantInfo(tenantUno:number) {
    this.spinner.show();
    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = tenantUno;
    inpValue.condition = 2;
    inpValue.userUno = this.loginUserID;//this.RASHelper.encryptWithPublicKey('1');

    
    this.restApi.getTenants(inpValue)
      .subscribe(data => {
        
        this.user = this.userService.getUserInfo();
        var isDigitalUser = (tenantUno == this.user.tenantDigitalUno) ? true : false;
        let tenantData: any = data;
        if (tenantData != null && tenantData.length > 0) {
          this.user.slaname = tenantData[0].slaName;
          this.user.siteHeading = tenantData[0].siteHeading;
          this.user.isDynamicEntry = (tenantData[0].isDynamicEntry==1)?'true':'false';
        }

        var struser = '{"id":"' + this.user.id + '","tenantDigitalUno":"' + this.user.tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + this.user.displayname + '","username":"' + this.user.username + '","firstname":"' + this.user.firstname + '","lastname":"' + this.user.lastname + '","email":"' + this.user.email + '","role":"' + this.user.role  + '","desingation":"' + this.user.desingation + '","division":"' + this.user.division + '","divisionUno":"' + this.user.divisionUno + '","profilePicture":"' + this.user.profilePicture + '","currentYear":"' + this.user.currentYear + '","currentHalf":"' + this.user.currentHalf + '","currentQuarter":"' + this.user.currentQuarter + '","currentMonth":"' + this.user.currentMonth + '","versionNumber":"' + this.user.versionNumber + '","wellperformKPIRange":"' + this.user.wellperformKPIRange + '","lastLogin":"' + this.user.lastLogin + '","tenantUno":"' + tenantUno + '","isDynamicEntry":"' + this.user.isDynamicEntry + '","siteHeading":"' + this.user.siteHeading + '","slaname":"' + this.user.slaname + '","userroleType":"' + this.user.userroleType + '","userGroupUno":"' + this.user.userGroupUno + '","userGroup":"' + this.user.userGroup + '"}';
        localStorage.removeItem('userinfo');
        localStorage.setItem('userinfo', struser);

        setTimeout(() => {
          
          //3-Sla Admin
          if (this.user.userroleType == 5 || this.user.userroleType == 6 || this.user.userroleType == 7 || this.user.userroleType == 8) {
            //this.router.navigate(['/benchmark-home']);
            if (this.IsBenchmarkAgreement == 0) {
              this.modalRef = this.modalService.show(this.agreementtemplate, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));
            }
            else {
              window.location.href = "#/benchmark-home";
            }
            
          }
          else if (this.user.tenantUno == 6) {

            
            let objusers = new Users;
            objusers.userUno = this.user.id;
            this.restApi.getDecryptUId(objusers)
              .subscribe(data => {
                //debugger;
                
                let rtnData = data;
                if (rtnData != null && rtnData != "0") {
                  let decryptUID = rtnData;
                  
                  var struser = '{"id":"' + decryptUID + '","tenantDigitalUno":"' + this.user.tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + this.user.displayname + '","username":"' + this.user.username + '","firstname":"' + this.user.firstname + '","lastname":"' + this.user.lastname + '","email":"' + this.user.email + '","role":"' + this.user.role + '","desingation":"' + this.user.desingation + '","division":"' + this.user.division + '","divisionUno":"' + this.user.divisionUno + '","profilePicture":"' + this.user.profilePicture + '","currentYear":"' + this.user.currentYear + '","currentHalf":"' + this.user.currentHalf + '","currentQuarter":"' + this.user.currentQuarter + '","currentMonth":"' + this.user.currentMonth + '","versionNumber":"' + this.user.versionNumber + '","wellperformKPIRange":"' + this.user.wellperformKPIRange + '","lastLogin":"' + this.user.lastLogin + '","tenantUno":"' + tenantUno + '","isDynamicEntry":"' + this.user.isDynamicEntry + '","siteHeading":"' + this.user.siteHeading + '","slaname":"' + this.user.slaname + '","userroleType":"' + this.user.userroleType + '","userGroupUno":"' + this.user.userGroupUno + '","userGroup":"' + this.user.userGroup + '"}';
                  localStorage.removeItem('userinfo');
                  localStorage.setItem('userinfo', struser);


                  window.location.href = "bsc/dashboard";
                }
                else {
                  window.location.href = "#/login";
                }
                
              },
                (error) => {

                  // this.spinner.hide();
                }
              ).add(() => {

                ///this.spinner.hide();
              });

            
          }
          else {
            window.location.href = "#/dashboard";
            //this.router.navigate(['/dashboard']);
          }

        }, 1000);
        this.loading = false;
        //console.log(this.postData);
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  acceptAgreement() {
    let objUser = new Users();
    objUser.userName = this.f.username.value.trim();
    objUser.condition = 6;
    objUser.confirmPassword = '';
    objUser.password = '';
    objUser.userUno = this.loginUserID;
    this.restApi.updateBMAgreement(objUser)
      .subscribe(data => {
        if (data == "success") {
          this.modalRef.hide();
          window.location.href = "#/benchmark-home";
        }
        else {
          this.toaster.show('error', 'Error', 'Error failed')
        }
      },
        () => {

        }
      ).add(() => {

      });
    
  }

  cancelAgreement() {
    this.modalRef.hide();
    this.userService.logout();
  }

  loadpairText() {
    
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        
        let rtnData: pairText;
        rtnData= data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
        this.recaptcha3.init(rtnData.sik);
      },
        (error) => {
          //Called when error
          
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        
      });
  }

  public resolved(token: string | null) {
    
    this.recapchaToken = token;
   
  }

  public formatToken(token: string | null) {
    return token !== null
      ? `${token.substr(0, 7)}...${token.substr(-7)}`
      : 'null';
  }

  //Authorize() {
  //  console.log("auhtorized called");
  //  this.authorizationService.authorize();
  //  this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
  //    this.authorized = tokenResponse != null;
  //    console.log("received response");
  //    console.log(this.authorized);
  //    console.log(tokenResponse);
  //    
  //    if (this.authorized) {
  //      let that = this;

  //    }
  //  });

  //}
}
